import styled from 'styled-components';
import Button from '../../components/common/Button';
import { theme } from '../../global';

export interface IButton {
  $isSquare?: boolean;
  $isPause?: boolean;
}

export const MainPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 20px;

  @media (max-width: 1358px) {
    gap: 20px;
    padding-top: 4px;
    min-height: calc(100vh - 8px - 72px);
    justify-content: space-between;
  }
`;

export const MainPageTimersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 40px;

  @media (max-width: 1358px) {
    gap: 16px;
  }
`;

export const MainPageButtonContainer = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;

  @media (max-width: 1358px) {
    width: 100%;
    height: 56px;
    margin: 0 auto;
    gap: 24px;
    padding-bottom: 120px;
    button {
      flex-direction: row;
    }
  }
`;

export const MainPageFooter = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 100%;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;

  @media (max-width: 1358px) {
    max-height: 0;
    //justify-content: left;
    //align-items: flex-end;
    //padding-bottom: 20px;
  }
`;

export const GameModeContainer = styled.div`
  width: 523px;
  @media (max-width: 1358px) {
    display: none;
  }
`;

export const MainPageButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 523px;
  justify-content: flex-end;

  button:nth-child(2),
  button:nth-child(3) {
    width: 48px;
    height: 48px;
    padding: unset;
    border-radius: 50%;
  }

  @media (max-width: 1358px) {
    position: fixed;
    right: 20px;
    top: 13px;

    button:nth-child(3),
    button:nth-child(1) {
      display: none;
    }
  }
`;

export const MainPagePauseButtonContainer = styled.div`
  display: flex;
  gap: 24px;
`;

export const PauseContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 40px;
  padding-top: 20px;

  button {
    height: 56px;
  }
`;

export const DesktopGameSettings = styled.div`
  display: none;

  @media (min-width: 1358px) {
    display: block;
  }
`;

export const MobileGameSettings = styled.div`
  display: none;
  position: fixed;
  left: 20px;
  top: 13px;

  @media (max-width: 1358px) {
    display: block;

    button {
      width: 48px;
      height: 48px;
      padding: unset;
      border-radius: 50%;
    }
  }
`;

export const MobileVoters = styled(MobileGameSettings)`
  left: unset;
  right: 78px;
`;

export const DesktopPassTurn = styled.div`
  display: none;

  @media (min-width: 1358px) {
    display: block;
  }
`;

export const MobilePassTurn = styled.div`
  display: none;
  padding-bottom: 40px;

  @media (max-width: 1358px) {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 20px;
    justify-content: flex-end;
  }
`;

export const CommonButton = styled(Button) <IButton>`
  width: 194px;
  height: 102px;
  display: flex;
  gap: 10px;
  flex-direction: column;
  border-radius: ${({ $isSquare }) => $isSquare && '20px'};
  background-color: ${({ $isPause }) => $isPause && theme.colors.pause};

  @media (max-width: 1358px) {
    border-radius: ${({ $isSquare }) => $isSquare && '16px'};
    height: 72px;
    width: 100%;
    font-size: 18px;
    line-height: 20px;
    align-items: center;
    display: flex;
  }
`;
